import React, { Component } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { confirmAlert } from 'react-confirm-alert';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import Modal from 'react-modal';

import services from '@C/CashiersOnDuty/_utils/data';
import { authHeader } from '@H';
import { UnlockDsr } from '@C/Dsr/Components';
import { LockOpen } from 'lucide-static';

class PastDuty extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      duties: [],
      lock: false,
      showModal: false,
    };
  }

  componentDidMount() {
    this.getDuties();
  }

  getDuties = () => {
    services
      .getPastDutyList(this.props.date)
      .then((response) => {
        this.setState({
          duties: response.data.data.duties_list,
          lock: response.data.data.dsr_lock,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  endDuty = (id, staff, name, date) => {
    this.props.onEndDuty(id, staff, name, date, true);
  };

  confirmCancel = (id, duty) => {
    confirmAlert({
      title: 'Confirm duty cancellation',
      message: 'Are you sure',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.cancelDuty(id, duty),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
    // this.getDuties();
    // this.getStaffList();
  };

  cancelDuty = (id, duty) => {
    const formData = {
      staff_id: id,
      cashier_duty_id: duty,
    };
    // this.getDuties();

    const headers = authHeader(1);
    axios
      .put(`${process.env.API_URL}/bunk/cancel-cashier-duty/`, formData, {
        headers,
      })
      .then(() => {
        toast.success('Duty cancelled successfully', {
          position: 'bottom-center',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        });
        window.location.reload();
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
    // this.getDuties();
    //   this.getStaffList();
    //   this.getGunsList();
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { duties } = this.state;
    const { timeLoggingEnabled } = this.props;
    if (duties.length === 0) {
      return <></>;
    } else {
      return (
        <>
          <section className="widget  duty-list past-duty-list">
            <header>
              <h3>Past Duties</h3>
            </header>
            <main>
              <ul>
                {duties.map((item, i) => {
                  return (
                    <li key={i}>
                      <div className="item-info">
                        <a href="#">
                          <span className="status --duty-completed">{`${item.first_name} ${item.last_name}`}</span>
                        </a>

                        {item.shift_name}

                        <span
                          title={`Duty date - ${dayjs(item.duty_time_stamp).format('YYYY-MM-DD')}`}
                        >
                          {timeLoggingEnabled
                            ? dayjs(item.duty_time_stamp).format(
                                'DD MMM YYYY, hh:mm A',
                              )
                            : new Date(item.duty_time_stamp).toDateString()}
                        </span>
                      </div>
                      <div className="cta-wrapper">
                        <Link
                          to={`/cashiers-on-duty/end-duty/${
                            item.cashier_duty_id
                          }/${dayjs(item.duty_time_stamp).format('YYYY-MM-DD')}/${
                            item.staff_uuid
                          }/view-duty/fuel-sales?ts=${encodeURIComponent(item.duty_time_stamp)}`}
                          className="end-cta"
                          style={{ marginRight: '5px' }}
                        >
                          View
                        </Link>
                        {!this.state.lock ? (
                          <>
                            <Link
                              to={`/cashiers-on-duty/end-duty/${
                                item.cashier_duty_id
                              }/${dayjs(item.duty_time_stamp).format('YYYY-MM-DD')}/${
                                item.staff_uuid
                              }/edit/fuel-sales?ts=${encodeURIComponent(item.duty_time_stamp)}${
                                item.end_duty_date_time
                                  ? `&endTs=${encodeURIComponent(item.end_duty_date_time)}`
                                  : ''
                              }`}
                              className="end-cta"
                            >
                              Edit
                            </Link>
                            <button
                              className="cancel-cta"
                              onClick={() =>
                                this.confirmCancel(
                                  item.staff_uuid,
                                  item.cashier_duty_id,
                                )
                              }
                            >
                              Delete
                            </button>
                          </>
                        ) : (
                          <>
                            <span className="disabled-error">DSR Locked</span>
                            <button
                              style={{ marginLeft: '5px' }}
                              className="icon-lock-open lucide-icon"
                              title="Unlock DSR"
                              onClick={() => this.setState({ showModal: true })}
                            ></button>
                          </>
                        )}
                      </div>
                      <Modal
                        isOpen={this.state.showModal}
                        onRequestClose={this.closeModal}
                        shouldCloseOnOverlayClick={true}
                        className="sub-xl-modal-container"
                        overlayClassName="xl-modal-overlay"
                        parentSelector={() => document.querySelector('body')}
                      >
                        <div className="modal-component">
                          <UnlockDsr
                            date={dayjs(item.duty_time_stamp).format(
                              'YYYY-MM-DD',
                            )}
                            onRequestClose={this.closeModal}
                          />
                        </div>
                      </Modal>
                    </li>
                  );
                })}
              </ul>
            </main>
          </section>
        </>
      );
    }
  }
}

export { PastDuty };
